export const CHART_CONTAINER_WIDTH = 250
export const CHART_CANVAS_WIDTH = 178
export const CHART_HEIGHT = 174
export const CHART_PADDING_X = 16
export const CHART_TOP = 12
export const BASELINE_HEIGHT = 26
export const CHART_INNER_HEIGHT = CHART_HEIGHT - CHART_TOP - BASELINE_HEIGHT
export const PREVIOUS_BAR_WIDTH = 28
export const CURRENT_BAR_WIDTH = 28
export const MOVEMENT_BAR_WIDTH = 8
export const MOVEMENT_BAR_GAP = 4
export const MOVEMENT_BAR_COUNT = 6
export const GROUP_GAP = 16
export const MIN_BAR_HEIGHT = 4
export const MIN_MOVEMENT_BAR_HEIGHT = 2

export const PREVIOUS_BAR_BACKGROUND =
  'repeating-linear-gradient(135deg, rgba(255, 255, 255, 0.16) 0 8px, rgba(255, 255, 255, 0) 8px 16px), linear-gradient(180deg, rgba(120, 144, 156, 0.65) 0%, rgba(120, 144, 156, 0.35) 100%)'

export const CURRENT_BAR_GRADIENT = 'linear-gradient(360deg, #FFD196 0%, #FFAB40 23.08%, #FFFFFF 100%)'

export const getBarHeight = (value: number, maxValue: number) => {
  if (value <= 0 || maxValue <= 0) {
    return 0
  }

  const scaledHeight = (value / maxValue) * CHART_INNER_HEIGHT

  return Math.max(scaledHeight, MIN_BAR_HEIGHT)
}
